import React, { Component } from "react";
import {
    Dialog,
    DialogContent,
    Grid,
    Typography,
    IconButton,
    InputAdornment,
    FormControl,
    OutlinedInput,
    Button,
    DialogActions,
    Paper,
    Box
} from "@mui/material";


import { useNavigate } from "react-router-dom";
import { ArrowLeft2, Eye, EyeSlash } from "iconsax-react";
import Loader from "../../../../components/ui/LoaderContainer";
import Snackbar1 from "../../../../components/ui/Snackbar";


const ChangePasswordPage = (props) => {
    const navigate = useNavigate();
    const { login, passwordChange } = props;

    class ChangePassword extends Component {
        constructor(props) {
            super(props);
            this.state = {
                currentPassword: "",
                newPassword: "",
                showPassword: false,
                confirmPassword: "",
            };
        }

        handleClickShowPassword = () => {
            this.setState((prevState) => ({
                showPassword: !prevState.showPassword,
            }));
        };

        handleMouseDownPassword = (event) => {
            event.preventDefault();
        };

        render() {
            const { showPassword, confirmPassword, currentPassword, newPassword } =
                this.state;

            return (
                <Grid container justifyContent="center" sx={{ mt: 4 }}>
                    <Grid item xs={12} md={8} lg={6}>
                        <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
                            <Button
                                variant="text"
                                sx={{
                                    color: "#031634",
                                    textTransform: "none",
                                    mb: 2,
                                    "&:hover": { backgroundColor: "#e6f2ff" },
                                }}
                                onClick={() => navigate(-1)} // Navigate back
                            >
                                <ArrowLeft2 /> Back
                            </Button>

                            <Typography
                                variant="h5"
                                textAlign={"center"}
                                mb={4}
                                style={{ color: "#031634", fontWeight: "bold" }}
                            >
                                Change Password
                            </Typography>


                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography style={{ color: "#333", fontSize: "14px", marginBottom: "8px", fontWeight: 600 }}>
                                        Current Password <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    <FormControl fullWidth>
                                        <OutlinedInput
                                            type={showPassword ? "text" : "password"}
                                            size="medium"
                                            value={currentPassword}
                                            sx={{ borderRadius: "12px" }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={this.handleClickShowPassword}
                                                        onMouseDown={this.handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? (
                                                            <EyeSlash color="#555" />
                                                        ) : (
                                                            <Eye color="#555" />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            onChange={(e) =>
                                                this.setState({ currentPassword: e.target.value })
                                            }
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography style={{ color: "#333", fontSize: "14px", marginBottom: "8px", fontWeight: 600 }}>
                                        New Password <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    <FormControl fullWidth>
                                        <OutlinedInput
                                            type={showPassword ? "text" : "password"}
                                            size="medium"
                                            value={newPassword}
                                            sx={{ borderRadius: "12px" }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={this.handleClickShowPassword}
                                                        onMouseDown={this.handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? (
                                                            <EyeSlash color="#555" />
                                                        ) : (
                                                            <Eye color="#555" />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            onChange={(e) =>
                                                this.setState({ newPassword: e.target.value })
                                            }
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography style={{ color: "#333", fontSize: "14px", marginBottom: "8px", fontWeight: 600 }}>
                                        Confirm New Password <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    <FormControl fullWidth>
                                        <OutlinedInput
                                            type={showPassword ? "text" : "password"}
                                            size="medium"
                                            value={confirmPassword}
                                            sx={{ borderRadius: "12px" }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={this.handleClickShowPassword}
                                                        onMouseDown={this.handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? (
                                                            <EyeSlash color="#555" />
                                                        ) : (
                                                            <Eye color="#555" />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            onChange={(e) =>
                                                this.setState({ confirmPassword: e.target.value })
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        backgroundColor: "#031634",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        py: 1.5,
                                        borderRadius: "12px",
                                        textTransform: "none",
                                        fontSize: "1rem",
                                        "&:hover": {
                                            backgroundColor: "#1a237e",
                                            boxShadow: "0 8px 16px rgba(0,0,0,0.2)"
                                        },
                                    }}
                                    onClick={() => {
                                        if (newPassword !== confirmPassword) {
                                            alert("New Password and Confirm Password do not match.");
                                            return;
                                        }
                                        passwordChange(
                                            login.token,
                                            login.user_id,
                                            currentPassword,
                                            newPassword
                                        );
                                        this.setState({
                                            currentPassword: "",
                                            newPassword: "",
                                            confirmPassword: "",
                                        });
                                    }}
                                >
                                    Update Password
                                </Button>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            );
        }
    }

    return (
        <React.Fragment>
            <ChangePassword {...props} />
            <Loader />
            <Snackbar1
                open={props.snackbar?.response_received}
                message={props.snackbar?.message}
                close_snack_bar={props.close_snack_bar}
            />
        </React.Fragment>
    );
};

export default ChangePasswordPage;
